"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var propTypes = {
    children: PropTypes.node,
};
var MailboxReadInfo = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "mailbox-read-info" }, children));
};
MailboxReadInfo.propTypes = propTypes;
exports.default = MailboxReadInfo;
//# sourceMappingURL=MailboxReadInfo.js.map